import { ReactComponent as ForbiddenSVG } from '../../assets/svg/Forbidden.svg'

export const Forbidden = () => (
  <div className="flex flex-col items-center justify-center " style={{ height: 'calc(100vh - 8rem)' }}>
    <div className="p-8 text-center h-[300px] w-[600px] flex flex-col items-center justify-center">
      <ForbiddenSVG />
      <p className="text-[20px] text-gray-800">
        You do not have permission to access this page.
      </p>
    </div>
  </div>
);
